import { z } from "zod";

/**
 * Per-ownership list counts powering the My / Team / All overview tab bubbles (PREC-3623).
 *
 * The backend DTO already coerces the SQL aggregates to numbers, but `z.coerce.number()` keeps
 * the boundary defensive — API count fields can surface as strings (see web CLAUDE.md §6).
 */
export const ListOwnershipCountsSchema = z.object({
	mine: z.coerce.number(),
	team: z.coerce.number(),
	all: z.coerce.number(),
});

export type ListOwnershipCounts = z.infer<typeof ListOwnershipCountsSchema>;
